import { render, staticRenderFns } from "./AttachmentGallery.vue?vue&type=template&id=7d060bde&"
import script from "./AttachmentGallery.vue?vue&type=script&lang=js&"
export * from "./AttachmentGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports